define('plugin/bonus/collection/BonusCollection',['require','lib/collection/ServerPaginatedCollection','plugin/bonus/model/BonusModel'],function (require) {

    var ServerPaginatedCollection = require('lib/collection/ServerPaginatedCollection');
    var BonusModel = require('plugin/bonus/model/BonusModel');

    /**
     * Bonus collection
     *
     * @class BonusCollection
     */
    return ServerPaginatedCollection.extend({

        url: '/ext/bonus/',
        model: BonusModel,

    });

});
